module.exports = __webpack_public_path__ + "img/Trash_Button.f8463ffa.svg";